import {createContext, useState, useEffect} from 'react';
import * as firebase from 'config/firebase.config';
import AuthenticationService from 'services/authentication.service';
import EmployeesService from 'services/employees.service';
import { on } from "infrastructure/eventHub";

const AuthenticationContext = createContext();
export default AuthenticationContext;

export function AuthenticationContextProvider(props) {
  const [auth, setAuth] = useState();
  const [user, setUser] = useState();

  useEffect(() => {
    const unsubAuthStateChanged = firebase.auth.onAuthStateChanged((auth) => {
      setAuth(auth);
    });

    const unsubUserStatusUpdate = on("user", "status", "update", ({ payload }) => {
      const { status } = payload;
      setUser((user) => {
        if (user) {
          return {...user, status};
        }
      });
    });

    return () => {
      unsubAuthStateChanged();
      unsubUserStatusUpdate();
    };
  }, []);

  useEffect(() => {
    if (auth !== undefined && auth !== null) {
      reload();
    }
  }, [auth])

  const reload = async () => {
    const user = {
      uid: auth.uid,
      email: auth.email,
      role: null,
      status: null
    };

    const [responseRole, responseStatus] = await Promise.all([
      AuthenticationService.getUserRole(),
      EmployeesService.getStatus()
    ]);

    user.role = responseRole.payload;
    user.status = responseStatus.payload;

    setUser(user);
  }

  return (
    <AuthenticationContext.Provider value={{auth, user, setUser, reload}}>
      {props.children}
    </AuthenticationContext.Provider>
  );
}